// extracted by mini-css-extract-plugin
export var categories = "fy_mc";
export var footerTop = "fy_mb";
export var footnote = "fy_cB";
export var footnoteContainer = "fy_hP";
export var subscriptionContainer = "fy_md";
export var wrapper = "fy_b9";